exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* Example Media queries\n *\n * @media (max-width: @kng-screen-xs-max) { ... }\n * @media (min-width: @kng-screen-sm-min) and (max-width: @kng-screen-sm-max) { ... }\n * @media (min-width: @kng-screen-md-min) and (max-width: @kng-screen-md-max) { ... }\n * @media (min-width: @kng-screen-lg-min) { ... }\n *\n */\n.attribute-cell {\n  display: inline-block;\n  margin-right: 30px;\n}\n.attribute-cell .cell-header {\n  color: #253b56;\n  font-size: 14px;\n  line-height: 18px;\n  font-weight: 400;\n  font-style: normal;\n  padding: 0;\n}\n.attribute-cell .cell-data {\n  color: #253b56;\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n  padding: 0;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/dclean-web-latest/task/cot-web/src/app/components/things/attributes/attributes.component.less
// module id = ../../../../../src/app/components/things/attributes/attributes.component.less
// module chunks = main